import { render, staticRenderFns } from "./ContratosDistribuidorasPage.vue?vue&type=template&id=29ec87f4&"
import script from "./ContratosDistribuidorasPage.vue?vue&type=script&lang=js&"
export * from "./ContratosDistribuidorasPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports